import * as React from "react";
import Alert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";
import { useSelector } from "react-redux";

export default function MyAlert() {
  const alerts = useSelector((state) => state.globalData.alerts);
  // console.log(alerts)
  function renderAlerts() {
    return alerts.map((alert, i) => (
      <Alert severity={alert.type} key={i}>
        {alert.text}
      </Alert>
    ));
  }

  return (
    <Stack sx={{ position: "fixed", top: 50, left: '50%', transform: 'translateX(-50%)', zIndex: 9999, pointerEvents: 'none' }} spacing={2}>
      {renderAlerts()}
      {/* <Alert severity="error">This is an error alert — check it out!</Alert>
      <Alert severity="warning">This is a warning alert — check it out!</Alert>
      <Alert severity="info">This is an info alert — check it out!</Alert>
      <Alert severity="success">This is a success alert — check it out!</Alert> */}
    </Stack>
  );
}
